import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { take } from 'rxjs';

import { ThoughtspotIntegrationService } from '@mode/shared/util-thoughtspot-integrated';
import { IconComponent } from '../icon/icon.component';

@Component({
  standalone: true,
  selector: 'capra-logo-button',
  imports: [CommonModule, IconComponent],
  templateUrl: './logo-button.component.html',
  styleUrls: ['./logo-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoButtonComponent implements OnInit {
  @Input() theme: 'light' | 'dark' = 'dark';
  @Input() hamburgerState: 'expanded' | 'collapsed' | undefined;
  @Output() clicked = new EventEmitter<void>();
  @HostBinding('class.analyst-studio') isAnalystStudio = false;

  constructor(private thoughtspotIntegrationService: ThoughtspotIntegrationService) {}

  ngOnInit(): void {
    this.thoughtspotIntegrationService.currOrgIntegrated$.pipe(take(1)).subscribe((enabled) => {
      this.isAnalystStudio = enabled;
    });
  }

  onClick(): void {
    if (!this.hamburgerState) {
      return;
    }
    this.clicked.emit();
  }
}
